import React from "react";
import ReactDOM from "react-dom";

import styled from "styled-components";
import CustomLoader from "./CustomLoader";

const PageLoader = ({ isLoading }) => {
  if (!isLoading) return null;
  
  return ReactDOM.createPortal(
    <FixedDimmer active={isLoading}>
      <CustomLoader />
    </FixedDimmer>,
    document.body
  );
};

const FixedDimmer = styled.div`
  display: ${(props) => (props.active ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000; // Higher than Semantic UI's modal (1000-1001)
  background: rgba(135, 169, 191, 0.42);
  backdrop-filter: blur(2px);
`;

export default PageLoader; 